import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import InputText from "../../components/forms/elements/InputText";
import OrdemTipoService from "../../services/OrdemTipoService";
import CrudForm from "../../components/forms/custom/CrudForm";

class FormOrdemTipo extends CrudForm {

    constructor(props) {
        super(props);

        this.state.model = {
            idOrdemTipo: "",
            nome: ""
        };

        this.state.crud = {
            service: OrdemTipoService,
            labels: {
                title: 'Tipo de Ordem',
            },
            urlList: '/LstOrdemTipo',
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderFields() {
        return (
            <div className="row mb-3 g-3">
                <InputText label="Código" md={3} value={this.state.model.idOrdemTipo} name="idOrdemTipo" readOnly opcionalLabel={false}/>
                <InputText label="Nome da Tipo de Ordem" autoFocus={true} required md={9} value={this.state.model.nome} name="nome" onChange={this.handleChange} maxLength={100} />
            </div>
        );
    }

    render() {
        return super.render();
    }
}

function With(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <FormOrdemTipo {...props} navigate={navigate} params={params} />
}

export default With